import { Coroutine, CoroutineManager } from '@sorskoot/wonderland-components';
import { Component, Object3D, PhysXComponent } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { CursorTarget } from '@wonderlandengine/components';
import { quat, ReadonlyQuat } from 'gl-matrix';
import { TimeManager } from '../core/time-manager.js';
import { TextsManager } from '../core/texts-manager.js';

const tempQuat = quat.create();
const startQuat: ReadonlyQuat = quat.create();
export class Door extends Component {
    static TypeName = 'door';

    @property.float(Math.PI / 2)
    targetRotation = Math.PI / 2;

    @property.float(1)
    duration = 1;

    @property.bool(true)
    closed = true;

    @property.bool(false)
    isLocked = false;

    @property.object()
    lockedMessageLocation?: Object3D;

    private _coroutineManager: CoroutineManager = new CoroutineManager();
    private _target!: CursorTarget;
    private _physxObject?: PhysXComponent;
    private _moving = false;
    private _initialRotation: ReadonlyQuat = quat.create();
    private _targetRotation = quat.create();
    init() {}

    start() {
        this._target = this.object.getComponent(CursorTarget)!; // Assuming the object has a CursorTarget component
        this.object.getRotationWorld(this._initialRotation);
        quat.rotateY(
            this._targetRotation,
            this._initialRotation,
            this.targetRotation
        );
    }

    onActivate(): void {
        this._physxObject = this.object.getComponent(PhysXComponent)!;
        // this._target.onHover.add(this._onhover);
        // this._target.onUnhover.add(this._onhover);
        this._target.onDown.add(this._ondown);
        // this._target.onUp.add(this._onup);
    }

    update(dt: number) {
        this._coroutineManager.update(dt);
    }

    unlock() {
        this.isLocked = false;
    }

    private _ondown = () => {
        if (this.isLocked) {
            if (this.lockedMessageLocation) {
                TextsManager.instance.showText(
                    'The door is locked.',
                    this.lockedMessageLocation
                );
            }
            return;
        }

        if (this._moving) {
            return;
        }
        if (this.closed) {
            this._moving = true;

            this._coroutineManager.addCoroutine(
                new Coroutine(this._openDoor())
            );
        } else {
            this._moving = true;

            this._coroutineManager.addCoroutine(
                new Coroutine(this._closeDoor())
            );
        }
    };
    private *_openDoor() {
        this.object.getRotationWorld(startQuat);

        const startTime = TimeManager.instance.time;

        while (TimeManager.instance.time < startTime + this.duration) {
            const t = (TimeManager.instance.time - startTime) / this.duration;
            quat.lerp(tempQuat, startQuat, this._targetRotation, t);
            this.object.setRotationWorld(tempQuat);
            yield;
        }
        this.object.setRotationWorld(this._targetRotation);
        this._moving = false;
        this.closed = false;
    }

    private *_closeDoor() {
        this.object.getRotationWorld(startQuat);

        const startTime = TimeManager.instance.time;

        // calculate T
        while (TimeManager.instance.time < startTime + this.duration) {
            const t = (TimeManager.instance.time - startTime) / this.duration;
            quat.lerp(tempQuat, startQuat, this._initialRotation, t);
            this.object.setRotationWorld(tempQuat);
            yield;
        }
        this.object.setRotationWorld(this._initialRotation);
        this._moving = false;
        this.closed = true;
    }
}
